import React, { useRef, useEffect } from "react";

import I18nHOC from "UIComponents/I18nHOC";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

export const MATHFIELD_ID = "calc-mathlive-field";
export const MAX_EQUATION_WIDTH = 520;
import "./MathLive.scss";

const MathLive = ({
  value,
  onChange,
  setToastMsg,
  shiftOn,
  mathLiveFieldContainerRef,
  hideBorder,
  handleEnter,
  handleBackspace,
  mathFieldId,
  customProps = {},
}) => {
  const timerRef = useRef();

  // used to control equation width [controlling physical control input] see onKeyboardButtonClick fn for virtual keyboard case
  useEffect(() => {
    const mf = document.getElementById(mathFieldId);
    if (mf) {
      mf.onKeystroke = ev => {
        if (!ev.metaKey && !ev.ctrlKey) {
          // limit width of equation
          const width = mf.getBoundingClientRect().width;
          if (width > MAX_EQUATION_WIDTH) {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(
              () => setToastMsg("toastMsgs:equation_width_limit_reached"),
              500
            );
            return false;
          }
        }
        return true;
      };
      mf.mathModeSpace = "\\;";
      mf.smartSuperscript = true;
      mf.smartFence = true;

      const isEnterEvent = e => e && (e.key === "Enter" || e.code === "Enter");

      const combinedKeydownHandler = e => {
        if (isEnterEvent(e) && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        if (
          isEnterEvent(e) &&
          mathFieldId === MATHFIELD_ID &&
          !e.metaKey &&
          !e.ctrlKey
        ) {
          handleEnter(value, true);
          e.preventDefault();
          return false;
        }
        return true;
      };

      mf.addEventListener("keydown", combinedKeydownHandler, true);

      return () => {
        mf.removeEventListener("keydown", combinedKeydownHandler, true);
      };
    }
  }, [
    value,
    shiftOn,
    mathLiveFieldContainerRef,
    mathFieldId,
    handleEnter,
    handleBackspace,
    setToastMsg,
  ]);

  return (
    <math-field
      ref={ref => {
        if (ref && mathLiveFieldContainerRef) {
          mathLiveFieldContainerRef.current = ref;
          ref.menuItems = [];
        }
      }}
      value={value}
      onInput={onChange}
      id={mathFieldId}
      default-mode="math" // inline-math, math
      letter-shape-style="upright"
      style={{
        border: hideBorder ? "none" : "1px solid #dbdbdb",
        padding: "0px 16px",
        marginRight: "none",
        marginBottom: "16px",
        marginTop: "16px",
        borderRadius: 4,
        fontSize: 18,
        width: "100%",
        height: "auto",
        maxHeight: 104,
        overflowY: "hidden",
        outline: "none",
        "--caret": "#333333",
        "--highlight": "#dedede",
        "--contains-highlight": "#dedede",
      }}
      {...customProps}
    >
      {value}
    </math-field>
  );
};

const mapActionCreators = {
  setToastMsg,
};

export default compose(
  I18nHOC({ resource: "toastMsgs" }),
  connect(s => s, mapActionCreators, null, { withRef: true })
)(MathLive);
